import { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import SiteLogo from './SiteLogo'
import { getAccountDashboard } from '@/services/dashboardService'
import { useAppTheme } from '@/theme/ThemeContext'

type NameState = 'loading' | 'loaded' | 'failed'

export default function FirstSection() {
  const [accountName, setAccountName] = useState('')
  const [nameState, setNameState] = useState<NameState>('loading')
  // Seeded like LogoBox: show the logo at once, then refine from the response.
  const [accountId, setAccountId] = useState<string | number | null>(() =>
    localStorage.getItem('accountId')
  )
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  useEffect(() => {
    let cancelled = false
    const fetchAccount = async () => {
      try {
        const data = await getAccountDashboard()
        if (cancelled) return
        setAccountName(data?.accountName ?? '')
        if (data?.accountId !== undefined && data?.accountId !== null) {
          setAccountId(data.accountId)
        }
        setNameState('loaded')
      } catch (error) {
        if (cancelled) return
        console.error('Failed to fetch account name:', error)
        setNameState('failed')
      }
    }
    void fetchAccount()
    return () => {
      cancelled = true
    }
  }, [])

  const nameText =
    nameState === 'loading'
      ? 'טוען...'
      : nameState === 'failed'
        ? 'טעינת שם האתר נכשלה'
        : accountName || 'לא הוגדר שם לאתר'

  return (
    <Box sx={{ direction: 'rtl' }}>
      <SiteLogo accountId={accountId} />
      <Box>
        <Typography
          sx={{
            color: isDarkMode ? '#BBD7FF' : '#000',
            textAlign: 'right',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: 300,
            lineHeight: '100%',
          }}
        >
          שם אתר
        </Typography>
        <Box display="flex" alignItems="center" gap="10px" py="20px">
          <Typography
            sx={{
              color: isDarkMode ? '#BBD7FF' : '#003F61',
              textAlign: 'right',
              fontFamily: 'Rubik',
              fontSize: '20px',
              fontWeight: 400,
              lineHeight: '24px',
            }}
          >
            {nameText}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
